import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Projects from "../views/Projects.vue";
import Photos from "../views/Photos.vue";
import Blog from "../views/Blog.vue";
import BlogTS from "../views/BlogTS.vue";
import BlogPost from '@/components/BlogPost';


Vue.use(VueRouter);

const routes = [
  {
    path: "/blog/:slug",
    name: "Blog Posts",
    component: BlogPost
  },
  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/projects",
    name: "Projects",
    component: Projects
  },
  {
    path: "/photos",
    name: "Photos",
    component: Photos
  },
  {
    path: "/blog",
    name: "Blog",
    component: Blog
  },
  {
    path: "/blog-ts",
    name: "Techstars",
    component: BlogTS
  },
  {
    path: "/",
    name: "Home",
    component: Home
  },
];

const router = new VueRouter({
  routes,
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  console.log(to)
  document.title = `${ process.env.VUE_APP_TITLE } - ${ to.name }`
  next()
});

export default router;
